module.exports = __webpack_public_path__ + "public/images/Testimonial_Xaviera.d967ff97e3040da0fd23e8427cfd95ee.webp";